"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerReviewRatingType;
(function (CustomerReviewRatingType) {
    CustomerReviewRatingType["Overall"] = "overall";
    CustomerReviewRatingType["Cleanliness"] = "cleanliness";
    CustomerReviewRatingType["Amenities"] = "amenities";
    CustomerReviewRatingType["Accuracy"] = "accuracy";
    CustomerReviewRatingType["StaffPerformance"] = "staff_performance";
    CustomerReviewRatingType["Location"] = "location";
    CustomerReviewRatingType["Value"] = "value";
    CustomerReviewRatingType["Public"] = "public";
    CustomerReviewRatingType["Private"] = "private";
})(CustomerReviewRatingType = exports.CustomerReviewRatingType || (exports.CustomerReviewRatingType = {}));
